import {create} from 'zustand';
import {UseListRequestFormsStoreProps} from './types';
import {DEFAULT_REQUEST_FORM} from '../../constants';

export const useListRequestFormsStore = create<UseListRequestFormsStoreProps>(set => ({
	list: [{...DEFAULT_REQUEST_FORM}],
	setList: list => set({list}),
	resetList: () => set({list: [{...DEFAULT_REQUEST_FORM}]}),
}));
